import cc from "classcat";
import { memo, type ReactNode } from "react";
import SortableItem from "../../../../src/components/dragAndDrop/SortableItem";
import RowDragIndicator from "./RowDragIndicator";
import styles from "./DashboardSectionRowContainer.module.scss";

const DashboardSectionRowContainer = memo(
  ({
    id,
    isSingleChildHalfRow,
    children
  }: {
    id: string;
    isSingleChildHalfRow: boolean;
    children: ReactNode;
  }) => (
    <SortableItem id={id}>
      {({ setNodeRef, attributes, listeners, style, isDragging }) => (
        <div
          ref={setNodeRef}
          style={style}
          className={cc([
            styles["row-container"],
            isDragging && styles["row-container--dragging"],
            isSingleChildHalfRow && styles["row-container--single-child"]
          ])}
          {...attributes}
          {...listeners}
        >
          <RowDragIndicator />
          {children}
        </div>
      )}
    </SortableItem>
  )
);

export default DashboardSectionRowContainer;
